// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// Get these from: https://app.supabase.com/project/_/settings/api
export const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
export const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Configure Supabase client with explicit auth settings.
// createClient throws if either argument is empty, so we only
// create the client when real credentials are present.
export const supabase = (supabaseUrl && supabaseAnonKey)
  ? createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storageKey: 'sb-auth-token', // Consistent storage key
    storage: localStorage,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
  : null; // Not configured — all service functions guard via isSupabaseConfigured()

// Helper function to check if Supabase is configured
export const isSupabaseConfigured = () => {
  return supabase !== null &&
         supabaseUrl !== '' &&
         supabaseAnonKey !== '';
};

// NOTE: window.supabase was removed for security. Use React DevTools or a debug build instead.
